import {ChangeDetectionStrategy, Component, input} from '@angular/core';

@Component({
  selector: 'app-maintenance-view',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './maintenance-view.component.html',
  styleUrl: './maintenance-view.component.scss',
})
export class MaintenanceViewComponent {
  title = input.required<string>();
  message = input.required<string>();
}
